import React from "react";
import { Text10, Text14, Text15, Text16, Text7 } from "./styles";
import { useApp } from "../../contexts";
import { CopyIcon2 } from "../Icons/CopyIcon";
import { Copy } from "../Copy";
import { Input } from "antd";
import { LinkItem } from "./LinkItem";
import { Tabs, Tooltip } from "antd";
import { InfoTooltipIcon } from "../../pages/Home/styles";
import { useWindowSize } from "../../hook/useWindowSize";
import { AFFILIATE_LINKS, ZENDESK_URLS } from "../../constants";

const MAP_TEXT_LINK = {
  "AI Avatar Store": "Promote AI Avatar Store",
  affiliate: "Promote AI Avatar Affiliate Program",
  suzuwalk: "Promote Art Walk",
  suzuneko: "Promote Suzuneko",
};

export const AffiliateLink = ({ data }) => {
  const { T, language } = useApp();
  const size = useWindowSize();

  const affiliateUrl = () => {
    switch (language) {
      case "ja":
        return ZENDESK_URLS.JA.AFFILIATE;
      case "ko":
        return ZENDESK_URLS.KO.AFFILIATE;
      case "cn":
        return ZENDESK_URLS.CN.AFFILIATE;
      case "tc": 
        return ZENDESK_URLS.TC.AFFILIATE;
      case "vi":
        return ZENDESK_URLS.VI.AFFILIATE;
      case "id":
        return ZENDESK_URLS.ID.AFFILIATE;
      case "pt":
        return ZENDESK_URLS.PT.AFFILIATE;
      case "es":
        return ZENDESK_URLS.ES.AFFILIATE;
      case "en":
      default:
        return ZENDESK_URLS.EN.AFFILIATE;
    }
  }

  return (
    <div
      className="w-[100%] px-[28px] py-[40px] lg:p-[60px] lg:pr-[100px] bg-[#fff]"
      style={{
        borderRadius: 14,
        boxShadow: "0px 0px 39.91735px 0px rgba(0, 0, 0, 0.15)",
      }}
    >
      <div>
        <Text7>{T("Affiliate Links")}</Text7>
      </div>
      <div className="mt-5 lg:mt-[35px] flex flex-col lg:flex-row gap-7 lg:gap-[100px]">
        <div className="flex gap-2 self-start items-center">
          <Text16 className="font-bold flex items-center">
            {" "}
            {T("Your referral code")}
            <Tooltip
              trigger={size.width < 768 ? "click" : "hover"}
              onClick={(e) => e.stopPropagation()}
              className="cursor-pointer mx-[5px]"
              color={"#EAF2FF"}
              overlayClassName={"note-tooltip"}
              title={
                <div
                  dangerouslySetInnerHTML={{
                    __html: T("referal_code_tooltip").replace('{url}', affiliateUrl()),
                  }}
                ></div>
              }
            >
              <span>
                <InfoTooltipIcon />
              </span>
            </Tooltip>
            :
          </Text16>
          {data?.affiliate?.referral_code && (
            <div className="flex gap-2">
              <Text10>{data?.affiliate?.referral_code}</Text10>
              <Copy
                text={data?.affiliate?.referral_code}
                isShowText={false}
                icon={<CopyIcon2 />}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-7  lg:gap-5 flex-1">
          <Text16> {T("Your affiliate link")}: </Text16>
          {data?.affiliate?.link && (
            <LinkItem
              title={T("Promote AI Avatar Store")}
              value={data?.affiliate?.link}
            />
          )}
          {(data?.lp_links ?? []).map((item) => (
            item.key !== 'suzuwalk' && item.key !== 'suzuneko' ? <LinkItem
            key={T(item?.text)}
            title={T(MAP_TEXT_LINK[item?.key])}
            value={item?.link}
          />: <></>
          ))}
          {(data?.user_link ?? []).map((item) => (
            <LinkItem
              key={item.oid}
              title={T("Promote Custom Link")}
              value={item?.link_url}
            />
          ))}
        </div>
      </div>
      <div className="mt-4 flex justify-end">
        <Text15 className="cursor-pointer">
          <a
            href={AFFILIATE_LINKS.OFFERS}
            target="_blank"
            rel="noreferrer"
          >
            {T("View more links")}
          </a>
        </Text15>
      </div>
    </div>
  );
};
